<router-outlet></router-outlet>
<div class="spinnerWrapper" [ngClass]="{ show: spinnerSer.isVisible && !isOnOidcBase }">
    <mat-spinner color="primary" class="spinner" [diameter]="75" role="img" [attr.aria-label]="translate('label.gb.loading')"></mat-spinner>
         <div style="position:relative; top: 0px; left: -65px;">{{translate('label.gb.loading')}}</div> 
</div>
